require("./sass/styles.scss");

import $ from "jquery";
var Slick = require("slick-carousel");
import OnePageNav from "./jquery.nav.js";
// nav($, window, document)

import ShopifyClient from "./shopify.js";
var shopify = new ShopifyClient();
shopify.init();

function testMenu() {
    if($("#logo").hasClass("current")) {
        $(".mainnav").removeClass("mainnav--show");
    } else {
        $(".mainnav").addClass("mainnav--show");
    }
}

function isMobile() {
    return $("#menubutton:visible").length != 0;
}

function isIE() {

    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        return true;
    }

    return false;
}

$(function() {
    $("#menubutton").click(function() {
        $(".mainnav").toggleClass("mainnav--open");
    });
    var mainnav = new OnePageNav($(".mainnav .menu"), {
        currentClass: 'current',
        scrollOffset: 54,
        scrollThreshold: 0.5,
        // easing: 'easeInOut',
        hashChange: true,
        scrollChange: function() {
            testMenu();
        }
    }).init();
    testMenu();
    $(".section_slider").each(function() {
        $(this).slick({
            arrows:true,
            dots:true,
            autoplay: !isMobile(),
            autoplaySpeed: 4000,
            speed: 2500,
            fade:true
        });
    });
    $("body").on("click", ".item", function() {
        //Hide all details
        $(".inserted_details").fadeOut().remove();

        //Search correct insertion point: Last with same offset
        var $insertionpoint;
        var myoffset = $(this).offset().top;
        $(".item", $(this).parent()).each(function() {
            if($(this).offset().top == myoffset)
                $insertionpoint = $(this);
        });

        if($(this).hasClass("item--open")) {
            $(".item-grid--activeitem").removeClass("item-grid--activeitem");
            $(".item--open").removeClass("item--open");
        } else {
            $(".item-grid--activeitem").removeClass("item-grid--activeitem");
            $(".item--open").removeClass("item--open");
            $(this).parent().addClass("item-grid--activeitem");
            $(this).addClass("item--open");

            //Insert details and show
            var $details = $(".details", $(this)).clone().insertAfter($insertionpoint);//.slideDown("slow");
            $details.each(function() { var redraw = this.offsetHeight});
            $details.addClass("inserted_details");

            //Init slider
            $(".details_slider", $details).each(function() {
                $(this).slick({
                    arrows:true,
                    dots:true,
                    autoplay: !isMobile(),
                    autoplaySpeed: 3000,
                    speed: 1000,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    pauseOnDotsHover: true
                });
            });

            //Init button
            $(".buy-button", $details).each(function() {
                shopify.initButton( this, $(this).data('product') );
            });
        }
        // console.log($insertionpoint);
    });
    $(".textbox--expandable").click(function() {
        var $mycontent = $(".textbox_hiddencontent", this);
        $(".textbox_hiddencontent").not($mycontent).hide();
        $mycontent.fadeToggle();
        $(this).toggleClass("textbox--open")
    });
    var initFilters = function(e) {
        e.preventDefault();
        var $section = $(this).parents(".section");
        $section.load(this.href + "?ajax=1", {}, function(response, status, xhr) {
            $(".filtermenu a", $section).click(initFilters);
        });
    }
    $(".filtermenu a").click(initFilters);
    $(window).scroll(function() {
        if(isIE())
            return;
        var pos = $(this).scrollTop();
        if(pos < 800) {
            var transition = pos/2;
            $("#home .section_slider").css("transform", "translateY("+transition+"px)");
        }
    });
})


// WEBPACK FOOTER //
// ./src/main.js